import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link, useNavigate, useLocation } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleSectionLink = (e, sectionId) => {
    e.preventDefault();

    // If we are already on the homepage
    if (location.pathname === '/') {
      const element = document.getElementById(sectionId);
      if (element) {
        const offsetTop = element.offsetTop - 120;
        window.scrollTo({ top: offsetTop, behavior: 'smooth' });
      }
    } else {
      // Navigate to homepage and pass the section to scroll to
      navigate('/', { state: { scrollTo: sectionId } });
    }
  };

  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-start">
          {/* Left - Logo and Tagline */}
          <Col lg={7} md={12} className="mb-4 mb-lg-0">
            <div className="footer-brand">
              <div className="nisa-logo">
                <img
                  src="/images/footer-logo.png"
                  alt="Nisa Care Logo"
                  className="footer-logo"
                />
              </div>
              <p className="footer-tagline">
                Your health, honored. Your faith, respected.<br />
                Your journey, supported at every age
              </p>
            </div>
          </Col>

          {/* Right - Three Columns */}
          <Col lg={5} md={12}>
            <Row>
              {/* App Column */}
              <Col sm={4} xs={6} className="mb-4">
                <h6 className="footer-heading">App</h6>
                <ul className="footer-links">
                  <li>
                    <a
                      href="#how-it-works"
                      onClick={(e) => handleSectionLink(e, 'how-it-works')}
                    >
                      Journey
                    </a>
                  </li>
                  <li>
                    <a
                      href="#features"
                      onClick={(e) => handleSectionLink(e, 'features')}
                    >
                      Features
                    </a>
                  </li>
                </ul>
              </Col>

              {/* Legal Column */}
              <Col sm={4} xs={6} className="mb-4">
                <h6 className="footer-heading">Legal</h6>
                <ul className="footer-links">
                  <li>
                    <Link to="/privacy-policy">Privacy Policy</Link>
                  </li>
                  <li>
                    <Link to="/contact">Contact Us</Link>
                  </li>
                </ul>
              </Col>

              {/* Social Column */}
              <Col sm={4} xs={12} className="mb-4">
                <h6 className="footer-heading">Social</h6>
                <ul className="footer-links">
                  <li><a href="https://www.instagram.com/nisacareofficial?igsh=MTdua3RkbTQ0cXMyeg==" target="_blank" rel="noopener noreferrer">instagram</a></li>
                  <li><a href="https://x.com/nisacare_?s=21&t=QwKzcKjRZEKeqRumc2Wt8g" target="_blank" rel="noopener noreferrer">X</a></li>
                  <li><a href="https://www.facebook.com/share/1DZACKQ5NN/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer">Facebook</a></li>
                </ul>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;